export default __webpack_public_path__ + "static/media/activeDownArrow.f9803224.svg";